import { PureComponent } from "react"
import PropTypes from "prop-types"

export default class SegmentedControlManager extends PureComponent {
  static propTypes = {
    children: PropTypes.func,
    options: PropTypes.array
  }

  constructor(props) {
    super()
    this.state = {
      value: props.options[0].value
    }
  }

  render() {
    return this.props.children({
      value: this.state.value,
      options: this.props.options,
      onChange: value => this.setState({ value })
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/segmented-control/segmented-control-manager.component.js